import { render, staticRenderFns } from "./cardSwiper.vue?vue&type=template&id=f5009074"
import script from "./cardSwiper.vue?vue&type=script&lang=js"
export * from "./cardSwiper.vue?vue&type=script&lang=js"
import style0 from "./cardSwiper.vue?vue&type=style&index=0&id=f5009074&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports